var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPocFullname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8662 27.4995C28.7784 27.6515 28.6521 27.7778 28.5001 27.8656C28.348 27.9533 28.1755 27.9995 28 27.9995H3.99995C3.8245 27.9993 3.65219 27.953 3.50031 27.8651C3.34843 27.7773 3.22234 27.651 3.13469 27.4991C3.04705 27.3471 3.00093 27.1747 3.00098 26.9992C3.00102 26.8238 3.04723 26.6514 3.13495 26.4995C5.0387 23.2082 7.97245 20.8482 11.3962 19.7295C9.70266 18.7213 8.38688 17.1851 7.65094 15.3567C6.91499 13.5284 6.79956 11.509 7.32238 9.60869C7.8452 7.70838 8.97735 6.03224 10.545 4.83765C12.1126 3.64306 14.029 2.99609 16 2.99609C17.9709 2.99609 19.8873 3.64306 21.4549 4.83765C23.0226 6.03224 24.1547 7.70838 24.6775 9.60869C25.2003 11.509 25.0849 13.5284 24.349 15.3567C23.613 17.1851 22.2972 18.7213 20.6037 19.7295C24.0275 20.8482 26.9612 23.2082 28.865 26.4995C28.9529 26.6514 28.9993 26.8238 28.9996 26.9993C28.9998 27.1749 28.9538 27.3474 28.8662 27.4995Z",
    fill: "#BCC1DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocFullname);
export default __webpack_public_path__ + "static/media/poc-fullname.cba1737b87d8a6c0ec69bd17a3e2e52c.svg";
export { ForwardRef as ReactComponent };